import { render, staticRenderFns } from "./social-btn-group.vue?vue&type=template&id=286b5a1f&scoped=true"
import script from "./social-btn-group.vue?vue&type=script&lang=js"
export * from "./social-btn-group.vue?vue&type=script&lang=js"
import style0 from "./social-btn-group.vue?vue&type=style&index=0&id=286b5a1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b5a1f",
  null
  
)

export default component.exports